export default "__VITE_ASSET__DfH$rkAe__"